import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { DataService } from './services/DataService';
import { minutesDiff } from './services/UtilityService';

const BookTicket = () => {
    var [airports, setAirports] = useState([]);
    const history = useNavigate();
    const [tripType, setTripType] = useState('one-way');
    const [from, setFrom] = useState('');
    const [to, setTo] = useState('');
    const [flightInformation, setFlightInformation] = useState({});
    const [passingersList, setPassingersList] = useState([{ id: 1 }]);
    const [searchParams, setSearchParams] = useSearchParams();


    useEffect(() => {
        window.scrollTo(0, 0)
        document.getElementById('b_header').style.setProperty('height', '96px');
        // var tpl = passingersList;
        // tpl.push(1);
        // setPassingersList(tpl)
        // alert(searchParams.get("id"))
        getFlightInfoById();
    }, [])



    const getFlightInfoById = async () => {
        var jsondata = await new DataService().getRouteDataById(searchParams.get("id"));
        console.log(jsondata)
        setFlightInformation(jsondata);
        // jsondata = jsondata.slice(0, 9);

    }

    var addPassinger = () => {
        var t = [...passingersList, { id: 2 }];
        //t.push({ id: 2 })
        console.log(t)
        setPassingersList(t)
    }

    var removePassinger = (p) => {
        var array = [...passingersList]; // make a separate copy of the array
        var index = array.indexOf(p)
        if (index !== -1) {
            array.splice(index, 1);
            setPassingersList(array)
        }
    }

    return (
        <>
            <section className="ftco-section ftco-no-pb ftco-no-pt">
                <div className="col-md heading-section">
                    {/* <span className="subheading">Available Frights</span> */}
                    <h6 className="mb-2 mt-2">Book Ticket </h6>
                </div>
                <div className="container1 container-main map-container">

                    <div className="row mt-5">
                        <div className="col-md-12 project-wrap" style={{ margin: 0, padding: 0 }}>
                            <div className="text p-2">
                                {flightInformation.FlightSegment && flightInformation.FlightSegment.map((segment, segIndex) => (

                                    <div key={segIndex}>
                                        {segIndex == 0 && <><div className='days'>
                                            <p>Flight: {flightInformation.OriginLocation} to {segment.LayoverAirport}</p>
                                        </div>
                                            <p>
                                                Airline: {segment.Airlines}<br></br>
                                                Departure: {new Date(flightInformation.DepartureTime).toLocaleString()} -
                                                Arrival: {new Date(segment.ArrivalTime).toLocaleString()}

                                            </p>
                                        </>}

                                        {(segIndex > 0 && segIndex < flightInformation.FlightSegment.length) && <div style={{ borderTop: '1px solid #ddd' }}>
                                            <p>

                                                <b> Waiting Time: {minutesDiff(flightInformation.FlightSegment[segIndex - 1].DepartureTime, flightInformation.FlightSegment[segIndex - 1].ArrivalTime)[1]}</b>
                                            </p>
                                            <div className='days'>

                                                <p>Flight: {flightInformation.FlightSegment[segIndex - 1].LayoverAirport} to {segment.LayoverAirport}</p>
                                            </div>
                                            <p>
                                                Airline: {segment.Airlines}<br></br>
                                                Departure: {new Date(flightInformation.FlightSegment[segIndex - 1].DepartureTime).toLocaleString()} -
                                                Arrival: {new Date(segment.ArrivalTime).toLocaleString()}
                                            </p>

                                        </div>}
                                        {flightInformation.FlightSegment.length != 1 && segIndex == flightInformation.FlightSegment.length - 1 && <div style={{ borderTop: '1px solid #ddd' }}>
                                            <p>
                                                <b> Waiting Time: {minutesDiff(flightInformation.FlightSegment[segIndex - 1].DepartureTime, segment.ArrivalTime)[1]}</b>
                                            </p>
                                            <div className='days'>
                                                <p>Flight: {segment.LayoverAirport} to {flightInformation.DestinationLocation}</p>
                                            </div>
                                            <p>
                                                Airline: {segment.Airlines}<br></br>
                                                Departure: {new Date(segment.DepartureTime).toLocaleString()} -
                                                Arrival: {new Date(flightInformation.ArrivalTime).toLocaleString()}
                                            </p>
                                        </div>}
                                        {flightInformation.FlightSegment.length == 1 && <div style={{ borderTop: '1px solid #ddd' }}>
                                            <p>
                                                <b> Waiting Time: {minutesDiff(flightInformation.FlightSegment[segIndex].DepartureTime, segment.ArrivalTime)[1]}</b>
                                            </p>
                                            <div className='days'>
                                                <p>Flight: {segment.LayoverAirport} to {flightInformation.DestinationLocation}</p>
                                            </div>
                                            <p>
                                                Airline: {segment.Airlines}<br></br>
                                                Departure: {new Date(segment.DepartureTime).toLocaleString()} -
                                                Arrival: {new Date(flightInformation.ArrivalTime).toLocaleString()}
                                            </p>
                                        </div>}
                                    </div>

                                ))}
                            </div>
                        </div>

                    </div>
                </div>
                <div className="col-md heading-section">
                    {/* <span className="subheading">Available Frights</span> */}
                    <h6 className="mb-2 mt-2">Traveller Details </h6>
                </div>
                <div className="container-main map-container" style={{ overflow: 'unset' }}>

                    <form action="#" className="search-property-1">

                        {passingersList.map((p, i) => {
                            return <>
                                <h6 className="mb-2 mt-2">Passinger {i + 1}
                                    {passingersList.length > 1 && <a className='pull-right' href='javascript:;' onClick={() => removePassinger(p)}>X</a>}
                                </h6>
                                <div className='row no-gutters'>
                                    <div className="col-md d-flex">
                                        <div className="form-group p-4  border-0">
                                            <label htmlFor="#">First Name</label>
                                            <div className="form-field">
                                                <div className="icon"><span className="fa fa-user"></span></div>
                                                <input type="text" className="form-control" placeholder="First Name" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md d-flex">
                                        <div className="form-group p-4">
                                            <label htmlFor="#">Last Name</label>
                                            <div className="form-field">
                                                <div className="icon"><span className="fa fa-user"></span></div>
                                                <input type="text" className="form-control" placeholder="Last Name" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md d-flex">
                                        <div className="form-group p-4">
                                            <label htmlFor="#">Gender</label>
                                            <div className="form-field">
                                                <div className="select-wrap">
                                                    <div className="icon"><span className="fa fa-chevron-down"></span></div>
                                                    <select className="form-control">
                                                        <option value="1">Select</option>
                                                        <option value="2">Male</option>
                                                        <option value="3">Female</option>
                                                        <option value="4">Others</option>
                                                    </select>


                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                </div>
                                <div className='row no-gutters' style={{ borderTop: '1px solid #efefef' }}>
                                    <div className="col-md d-flex">
                                        <div className="form-group p-4  border-0">
                                            <label htmlFor="#">Country Code</label>
                                            <div className="form-field">
                                                <div className="select-wrap">
                                                    <div className="icon"><span className="fa fa-chevron-down"></span></div>
                                                    <select className="form-control">
                                                        <option value="Economy">India (91)</option>
                                                        <option value="Economy">USA (1)</option>
                                                        <option value="PremiumEconomy">UK (44)</option>
                                                    </select>


                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md d-flex">
                                        <div className="form-group p-4">
                                            <label htmlFor="#">Mobile No</label>
                                            <div className="form-field">
                                                <div className="select-wrap">
                                                    <div className="icon"><span className="fa fa-phone"></span></div>
                                                    <input type="text" className="form-control" placeholder="Mobile No" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md d-flex">
                                        <div className="form-group p-4">
                                            <label htmlFor="#">Email</label>
                                            <div className="form-field">
                                                <div className="select-wrap">
                                                    <div className="icon"><span className="fa fa-envelope"></span></div>
                                                    <input type="text" className="form-control" placeholder="Email" />                                        </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='row no-gutters' style={{ borderTop: '1px solid #efefef' }}>
                                    <div className="col-md d-flex">
                                        <div className="form-group p-4 border-0">
                                            <label htmlFor="#">Date of birth</label>
                                            <div className="form-field">
                                                <div className="icon"><span className="fa fa-calendar"></span></div>
                                                <DatePicker

                                                    dateFormat="dd MMM yyyy"
                                                    required
                                                    placeholderText="Date of birth"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='row no-gutters' style={{ borderTop: '1px solid #efefef' }}>
                                    <div className="col-md d-flex">
                                        <div className="form-group p-4 border-0">
                                            <label htmlFor="#">Passport No</label>
                                            <div className="form-field">
                                                <div className="icon"><span className="fa fa-file"></span></div>
                                                <div className='returndate'>
                                                    <input type='text' className="form-control" placeholder='Passport No'></input>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md d-flex">
                                        <div className="form-group p-4">
                                            <label htmlFor="#">Passport Issuing Country</label>
                                            <div className="form-field">
                                                <div className="select-wrap">
                                                    <div className="icon"><span className="fa fa-map-marker"></span></div>
                                                    <select className="form-control">
                                                        <option value="Economy">Select</option>
                                                        <option value="Economy">India</option>
                                                        <option value="Economy">USA</option>
                                                        <option value="PremiumEconomy">UK</option>
                                                    </select>


                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md d-flex">
                                        <div className="form-group p-4">
                                            <label htmlFor="#">Passport expirty date</label>
                                            <div className="form-field">
                                                <div className="icon"><span className="fa fa-calendar"></span></div>
                                                <div className='returndate'>
                                                    <DatePicker

                                                        dateFormat="dd MMM yyyy"
                                                        required
                                                        placeholderText="Passport expirty date"

                                                    />

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </>
                        })}

                    </form>
                </div>
                <div className='row no-gutters' style={{ borderTop: '1px solid #efefef' }}>
                    <div className="col-md ">
                        <div className="form-group border-0">
                            <div className="form-field float-end">
                                <input type="submit" value="+ Add" onClick={addPassinger} className="align-self-stretch btn btn-primary search_button" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container-main map-container">
                    <div className='row no-gutters' style={{ borderTop: '1px solid #efefef' }}>
                        <div className="col-md ">
                            <div className="form-group border-0">
                                <div className="form-field float-end">
                                    <input type="submit" value="Confirm" className="align-self-stretch btn btn-primary search_button" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


        </>
    );
};

export default BookTicket;